(function () {
  if (window.__dcodedCartSubscribeSaveInit) return;
  window.__dcodedCartSubscribeSaveInit = true;

  const SUBSCRIBE_TAB_TEXT = 'subscribe & save';
  const ONE_TIME_TAB_TEXT = 'one-time purchase';

  const normalize = (value) => (value || '').toLowerCase().replace(/\s+/g, ' ').trim();

  const parsePlanMap = (el) => {
    const script = el?.querySelector('[data-subscribe-plans]');
    if (script) {
      try {
        return JSON.parse(script.textContent || '{}');
      } catch {
        return {};
      }
    }

    const raw = el?.dataset?.planMap;
    if (!raw) return {};

    const map = {};
    raw.split(',').forEach((entry) => {
      const [variantId, planId] = entry.split(':');
      if (variantId && planId) {
        map[variantId] = [{ id: planId, name: '' }];
      }
    });
    return map;
  };

  const pickPlanId = (plans, quantity) => {
    if (!plans?.length) return null;
    if (plans.length === 1) return String(plans[0].id);

    const pack3 = plans.find((plan) => normalize(plan.name).includes('3 pack'));
    const pack1 = plans.find((plan) => normalize(plan.name).includes('1 pack'));

    if (quantity >= 3 && pack3) return String(pack3.id);
    if (pack1) return String(pack1.id);

    return String(plans[0].id);
  };

  const getCartChangeUrl = () => {
    if (typeof Shopify !== 'undefined' && Shopify.routes?.root) {
      return Shopify.routes.root + 'cart/change.js';
    }
    return '/cart/change.js';
  };

  const getCartUrl = () => {
    if (typeof Shopify !== 'undefined' && Shopify.routes?.root) {
      return Shopify.routes.root + 'cart.js';
    }
    return '/cart.js';
  };

  const getDrawerSectionId = () => {
    const drawer = document.getElementById('cart-drawer') || document.querySelector('cart-drawer');
    if (drawer?.dataset?.sectionId) return drawer.dataset.sectionId;

    const section = document.querySelector('.shopify-section[id*="cart-drawer"]');
    if (section?.id) return section.id.replace('shopify-section-', '');

    const promo = document.querySelector('dcoded-cart-subscribe-save[data-section-id]');
    return promo?.dataset?.sectionId || '';
  };

  const getSectionIds = (el) => {
    const sectionId = getDrawerSectionId();
    const ids = sectionId ? [sectionId] : [];

    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: ids }
    }));

    return ids;
  };

  const refreshCart = (data) => {
    if (window.themeVariables?.settings?.pageType === 'cart') {
      window.location.reload();
      return;
    }

    const cartDrawer = document.getElementById('cart-drawer') || document.querySelector('cart-drawer');
    const drawerWasOpen = Boolean(cartDrawer?.open);
    const sectionId = getDrawerSectionId();
    const hasSections = Boolean(sectionId && data?.sections?.[sectionId]);

    if (hasSections) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'subscribe:update',
          cart: data
        }
      }));
    } else {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
    }

    if (drawerWasOpen && cartDrawer && !cartDrawer.open) {
      cartDrawer.show();
    }
  };

  const updateCheckoutPrice = (totalPrice) => {
    const checkoutPrices = document.querySelectorAll('[data-cart-total-price], .cart-drawer__button-price, .cart-drawer__total-price');
    if (!checkoutPrices.length || totalPrice == null) return;

    const format = window.themeVariables?.moneyFormat || '${{amount}}';
    const amount = (totalPrice / 100).toFixed(2);
    const formatted = format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(totalPrice / 100))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(totalPrice / 100))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);

    checkoutPrices.forEach((el) => {
      el.textContent = formatted;
    });
  };

  const computeAllSubscribedFromCart = (cart, el) => {
    const lineKey = el?.dataset?.lineKey;
    const planMap = parsePlanMap(el);

    if (lineKey) {
      const item = cart.items?.find((entry) => entry.key === lineKey);
      if (!item) return null;

      const planId = pickPlanId(planMap[String(item.variant_id)], item.quantity);
      if (!planId) return null;

      return Boolean(item.selling_plan_allocation);
    }

    let hasSubscribable = false;
    let allSubscribed = true;

    cart.items?.forEach((item) => {
      const planId = pickPlanId(planMap[String(item.variant_id)], item.quantity);
      if (!planId) return;

      hasSubscribable = true;
      if (!item.selling_plan_allocation) allSubscribed = false;
    });

    return hasSubscribable ? allSubscribed : null;
  };

  const syncToggleFromCart = (el, cart) => {
    const toggle = el?.querySelector('[data-subscribe-toggle]');
    if (!toggle || el.classList.contains('dcoded-subscribe-save--loading')) return;

    const allSubscribed = computeAllSubscribedFromCart(cart, el);
    if (allSubscribed === null) return;

    toggle.checked = allSubscribed;
    el.dataset.allSubscribed = allSubscribed ? 'true' : 'false';
  };

  const syncAllTogglesFromCart = (cart) => {
    document.querySelectorAll('dcoded-cart-subscribe-save').forEach((el) => {
      syncToggleFromCart(el, cart);
    });
  };

  const getPlanIdForCartItem = (item) => {
    const lineEl = document.querySelector(`dcoded-cart-subscribe-save[data-line-key="${item.key}"]`);
    if (lineEl) return lineEl._getPlanId(item.variant_id, item.quantity);

    for (const el of document.querySelectorAll('dcoded-cart-subscribe-save')) {
      const planId = el._getPlanId(item.variant_id, item.quantity);
      if (planId) return planId;
    }

    return null;
  };

  const isSubscribeModeActive = () => Boolean(document.querySelector('.kaching-mode-subscribe'));

  const isKachingPurchaseControl = (clicked) => {
    const text = normalize(clicked.textContent);
    if (!text.includes(SUBSCRIBE_TAB_TEXT) && !text.includes(ONE_TIME_TAB_TEXT)) return false;

    const root = clicked.closest('form, section, article, div');
    return Boolean(
      root?.querySelector('.kaching-bundles__bar, kaching-subscriptions-block, kaching-bundles, kaching-subscriptions-block')
    );
  };

  let pdpSyncTimer = null;
  let pdpApplyInProgress = false;

  class DcodedCartSubscribeSave extends HTMLElement {
    connectedCallback() {
      this._toggle = this.querySelector('[data-subscribe-toggle]');
      this._planMap = parsePlanMap(this);
      this._toggle?.addEventListener('change', () => this._onToggle());
    }

    _getPlanId(variantId, quantity) {
      return pickPlanId(this._planMap[String(variantId)], quantity);
    }

    _setLoading(isLoading) {
      this.classList.toggle('dcoded-subscribe-save--loading', isLoading);
      if (this._toggle) this._toggle.disabled = isLoading;
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:' + (isLoading ? 'start' : 'end'), { bubbles: true }));
    }

    async _fetchCart() {
      const res = await fetch(getCartUrl(), {
        headers: { Accept: 'application/json' }
      });
      return res.json();
    }

    async _changeItem(lineKey, quantity, sellingPlan, includeSections) {
      const body = {
        id: lineKey,
        quantity,
        selling_plan: sellingPlan || ''
      };

      if (includeSections) {
        const sectionIds = getSectionIds(this);
        if (sectionIds.length) {
          body.sections = sectionIds.join(',');
          body.sections_url = window.location.pathname;
        }
      }

      const res = await fetch(getCartChangeUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      });

      if (!res.ok) {
        const error = await res.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Could not update subscription.');
      }

      return res.json();
    }

    _cartNeedsSubscriptionChange(cart, subscribe) {
      return cart.items?.some((item) => {
        const planId = this._getPlanId(item.variant_id, item.quantity);
        if (!planId) return false;

        const isSubscribed = Boolean(item.selling_plan_allocation);
        return subscribe ? !isSubscribed : isSubscribed;
      });
    }

    async _applyLineItemSubscription(lineKey, subscribe) {
      let cart = await this._fetchCart();
      const item = cart.items?.find((entry) => entry.key === lineKey);
      if (!item) return cart;

      const planId = this._getPlanId(item.variant_id, item.quantity);
      if (!planId) return cart;

      const isSubscribed = Boolean(item.selling_plan_allocation);
      if (subscribe === isSubscribed) {
        if (this._toggle) this._toggle.checked = subscribe;
        this.dataset.allSubscribed = subscribe ? 'true' : 'false';
        return cart;
      }

      const lastCart = await this._changeItem(
        item.key,
        item.quantity,
        subscribe ? planId : '',
        true
      );

      if (this._toggle) this._toggle.checked = subscribe;
      this.dataset.allSubscribed = subscribe ? 'true' : 'false';
      updateCheckoutPrice(lastCart.total_price);
      refreshCart(lastCart);
      return lastCart;
    }

    async _applySubscriptionState(subscribe) {
      let cart = await this._fetchCart();
      const pending = [];

      cart.items.forEach((item) => {
        const planId = this._getPlanId(item.variant_id, item.quantity);
        if (!planId) return;

        const isSubscribed = Boolean(item.selling_plan_allocation);
        if (subscribe && isSubscribed) return;
        if (!subscribe && !isSubscribed) return;

        pending.push(item);
      });

      if (!pending.length) {
        if (this._toggle) this._toggle.checked = subscribe;
        this.dataset.allSubscribed = subscribe ? 'true' : 'false';
        return cart;
      }

      let lastCart = cart;

      for (let i = 0; i < pending.length; i += 1) {
        const item = pending[i];
        const current = lastCart.items.find((entry) => entry.variant_id === item.variant_id);
        if (!current) continue;

        const planId = this._getPlanId(current.variant_id, current.quantity);
        lastCart = await this._changeItem(
          current.key,
          current.quantity,
          subscribe ? planId : '',
          i === pending.length - 1
        );
      }

      if (this._toggle) this._toggle.checked = subscribe;
      this.dataset.allSubscribed = subscribe ? 'true' : 'false';
      updateCheckoutPrice(lastCart.total_price);
      refreshCart(lastCart);
      return lastCart;
    }

    async _onToggle() {
      const subscribe = this._toggle.checked;
      const previousState = !subscribe;
      const lineKey = this.dataset.lineKey;

      this._setLoading(true);

      try {
        if (lineKey) {
          await this._applyLineItemSubscription(lineKey, subscribe);
        } else {
          await this._applySubscriptionState(subscribe);
        }
      } catch (error) {
        this._toggle.checked = previousState;
        console.error('Failed to update cart subscription', error);
      } finally {
        this._setLoading(false);
      }
    }

    static async _applyAllItemsSubscription(subscribe) {
      const elements = [...document.querySelectorAll('dcoded-cart-subscribe-save')];
      if (!elements.length) return;

      const controller = elements.find((el) => !el.classList.contains('dcoded-subscribe-save--loading')) || elements[0];
      if (!controller || controller.classList.contains('dcoded-subscribe-save--loading')) return;

      let cart = await controller._fetchCart();
      if (!cart.items?.length) return;

      const pending = [];

      cart.items.forEach((item) => {
        const planId = getPlanIdForCartItem(item);
        if (!planId) return;

        const isSubscribed = Boolean(item.selling_plan_allocation);
        if (subscribe && isSubscribed) return;
        if (!subscribe && !isSubscribed) return;

        pending.push(item);
      });

      elements.forEach((el) => {
        if (el._toggle) el._toggle.checked = subscribe;
        el.dataset.allSubscribed = subscribe ? 'true' : 'false';
      });

      if (!pending.length) {
        syncAllTogglesFromCart(cart);
        return;
      }

      pdpApplyInProgress = true;
      elements.forEach((el) => el._setLoading(true));

      try {
        let lastCart = cart;

        for (let i = 0; i < pending.length; i += 1) {
          const item = pending[i];
          const current = lastCart.items.find((entry) => entry.key === item.key);
          if (!current) continue;

          const planId = getPlanIdForCartItem(current);
          if (!planId) continue;

          lastCart = await controller._changeItem(
            current.key,
            current.quantity,
            subscribe ? planId : '',
            i === pending.length - 1
          );
        }

        updateCheckoutPrice(lastCart.total_price);
        refreshCart(lastCart);
        syncAllTogglesFromCart(lastCart);
      } catch (error) {
        console.error('Failed to sync cart subscription from PDP', error);
        syncAllTogglesFromCart(cart);
      } finally {
        elements.forEach((el) => el._setLoading(false));
        pdpApplyInProgress = false;
      }
    }

    static async applyCartMode(subscribe) {
      await DcodedCartSubscribeSave._applyAllItemsSubscription(subscribe);
    }
  }

  if (!customElements.get('dcoded-cart-subscribe-save')) {
    customElements.define('dcoded-cart-subscribe-save', DcodedCartSubscribeSave);
  }

  const schedulePdpCartSync = (subscribe) => {
    clearTimeout(pdpSyncTimer);
    pdpSyncTimer = setTimeout(() => {
      DcodedCartSubscribeSave.applyCartMode(subscribe);
    }, 150);
  };

  document.addEventListener('click', (event) => {
    if (window.themeVariables?.settings?.pageType !== 'product') return;

    const clicked = event.target.closest('button, [role="button"], a, label');
    if (!clicked || !isKachingPurchaseControl(clicked)) return;

    const text = normalize(clicked.textContent);
    if (text.includes(SUBSCRIBE_TAB_TEXT)) {
      schedulePdpCartSync(true);
    } else if (text.includes(ONE_TIME_TAB_TEXT)) {
      schedulePdpCartSync(false);
    }
  });

  document.addEventListener('variant:add', (event) => {
    const cart = event.detail?.cart;
    setTimeout(async () => {
      if (pdpApplyInProgress) return;

      if (isSubscribeModeActive()) {
        await DcodedCartSubscribeSave.applyCartMode(true);
        return;
      }

      const latestCart = cart || await fetch(getCartUrl(), { headers: { Accept: 'application/json' } }).then((r) => r.json());
      syncAllTogglesFromCart(latestCart);
    }, 80);
  });

  document.documentElement.addEventListener('cart:change', (event) => {
    const cart = event.detail?.cart;
    if (!cart) return;

    syncAllTogglesFromCart(cart);
    updateCheckoutPrice(cart.total_price);
  });

  document.addEventListener('cart-drawer:refreshed', async () => {
    try {
      const cart = await fetch(getCartUrl(), { headers: { Accept: 'application/json' } }).then((r) => r.json());
      syncAllTogglesFromCart(cart);
    } catch {
      /* ignore */
    }
  });
})();
